import { render, staticRenderFns } from "./BackoutDetail.vue?vue&type=template&id=04d0b5d6&"
import script from "./BackoutDetail.vue?vue&type=script&lang=js&"
export * from "./BackoutDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports